import React from 'react';
import { Icons, SVG, SVGIcon } from '../../../components/atoms/SVG';
import { ReactionType } from '../PageInstantReaction.types';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum PageInstantReactionIconModifier {
  SMALL = 'small',
}

type PageInstantReactionIconProps = {
  reaction: ReactionType;
  count?: number;
  reactionInformation?: boolean;
  modifier?: Modifier<PageInstantReactionIconModifier>;
};

export const TAB_ICON_CONFIG: Record<ReactionType, SVGIcon> = {
  like: Icons.THUMB_LIKE,
  approval: Icons.APPROVAL,
  valuable: Icons.VALUABLE,
  interesting: Icons.LIGHTBULB,
};

export function PageInstantReactionIcon({
  reaction,
  count,
  reactionInformation,
  modifier,
}: PageInstantReactionIconProps) {
  const { t } = useSonTranslation('PageInstantReaction');

  return (
    <span className="page-instant-reaction__icon-outer-container">
      <span className={bem('page-instant-reaction__icon', modifier)}>
        <span className={`page-instant-reaction__icon-container page-instant-reaction__icon-container--${reaction}`}>
          <SVG svgSpriteId={TAB_ICON_CONFIG[reaction]} />
        </span>
        {count !== undefined ? (
          <span className="page-instant-reaction__count" aria-hidden="true">
            {count}
          </span>
        ) : null}
      </span>
      {reactionInformation ? (
        <span className="page-instant-reaction__reaction font-regular-13-16">{t(`reactions.${reaction}`)}</span>
      ) : null}
    </span>
  );
}
